import router from '../router';
import store from '../store';

export default {
    clickAdvertisement(advrt) {
        if (advrt.advrtActTypeCode === 'SALE_CATG') {
            const advrtSaleCatgSlctCode = advrt.advrtSaleCatgSlctCode;
            if (
                advrtSaleCatgSlctCode &&
                store.getters.productListSaleCatgList.some(
                    c => c.saleCatgSlctCode === advrtSaleCatgSlctCode
                )
            ) {
                router.push(
                    store.getters.productGroupRoute(advrtSaleCatgSlctCode)
                );
            }
        } else if (advrt.advrtActTypeCode === 'PROD' && advrt.advrtProdKey) {
            const matchProduct = store.getters.productList.find(
                p => p.prodKey === advrt.advrtProdKey
            );
            if (matchProduct) {
                router.push(store.getters.productDetailRoute(matchProduct.id));
            } else if (advrt.advrtProdId) {
                router.push(`/productInfo/${advrt.advrtProdId}`);
            }
        } else if (advrt.advrtActTypeCode === 'URL' && advrt.advrtUrl) {
            window.open(advrt.advrtUrl);
        } else if (
            advrt.advrtActTypeCode === 'POP' ||
            advrt.advrtActTypeCode === 'URLPOP'
        ) {
            store.state.popupAdvertisement = advrt;
        }
    }
};
